<template>
    <f7-page name="smogovy-system-detail" @page:init="onPageInit">
        <f7-navbar>
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
            <f7-nav-right>
                <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
                <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
            </f7-nav-right>
        </f7-navbar>

        <f7-list media-list class="smogdetail" v-if="isDataLoaded">
            <f7-list-item v-for="(item, index) in loadedData.data" :key="index"
                          v-if="loadedData.data"
                          :no-chevron="true"
                          :class="'level-'+item.level"
                          :link="'/kvalita-ovzdusia/detail/'+selectedStationId+'/'+item.pollutant_id"
            >
                <div class="item-title-row">
                    <div class="item-title" v-html="getVelicina(item)"></div>
                    <div class="item-after">
                        <span>{{ item.value }} µg/m<sup>3</sup></span>
                    </div>
                </div>
                <div class="item-footer">
                    <template v-if="item.pollutant_id !== 'pm10_dpr'">
                    Dátum merania: {{ item.dt*1000 | moment('DD.MM.YYYY HH:mm') }}
                    </template>
                    <template v-else>
                        Dátum: {{ item.dt*1000 | moment('DD.MM.YYYY') }}
                    </template>
                </div>
            </f7-list-item>
        </f7-list>


    </f7-page>
</template>
<script>
    import Axios from "axios";
    import SHMUconf from "../js/SHMUconf";



    export default {
        data: function () {
            return {
                pageTitle: 'Smogový varovný systém',
                selectedStationId: null,
                lastUpdated: 0,
                tCheckInterval: null,
                isDataLoaded: false,
                loadedData: [],
            };
        },
        watch: {
            loadedData() {
                this.pageTitle = this.loadedData.station.station_name + ' - Smogový varovný systém';
            }
        },
        mounted() {
            const self = this;
            // otvorime hlavne menu
            this.$f7.accordion.close('.shmu-i-kvalita-ovzdusia');
            this.$f7.accordion.open('.shmu-i-kvalita-ovzdusia');
        },
        destroy() {
            clearInterval(this.tCheckInterval);
        },
        methods: {
            onPageInit() {
                this.selectedStationId = this.$f7route.params.station_id;
                this.pageReload(null, true);
            },
            pageReload(event, isInit) {
                const self = this;

                if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) {
                    this.loadSmogDetailData();
                }

            },
            loadSmogDetailData: function() {
                const self = this;

                self.$f7.dialog.preloader('Načítavam...');
                Axios.get(SHMUconf.API_BASE_URL + 'airquality/getlatestdata?station=' + this.selectedStationId, {
                    crossDomain: true,
                    cache: false,
                })
                    .then((response) => {
                        if (!response.data.error) {
                            self.loadedData = response.data;
                            self.isDataLoaded = true;
                            self.lastUpdated = self.$moment().unix();
                            // clearInterval(this.tCheckInterval);
                            // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min

                        } else {
                            self.$f7.dialog.alert('Nepodarilo sa načítať údaje o znečisťujúcich látkach k vybranej stanici', 'Nastala chyba');
                        }
                        self.$f7.dialog.close();
                    }).catch((error) => {
                    self.$f7.dialog.close();
                    self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
                });
            },
            getVelicina(item) {
                if (item.pollutant_id === 'pm10_dpr') return 'Dpr. PM<sub>10</sub>';
                else if (item.pollutant_id === 'pm10_12h') return '12-h PM<sub>10</sub>';
                else {
                 let obj = this.loadedData.station.pollutants.find(x => x.pollutant_id === item.pollutant_id)
                    if (obj) {
                        let desc = obj.pollutant_desc;
                        if (desc === 'PM10') desc = 'PM<sub>10</sub>';
                        else if (desc === 'PM2.5') desc = 'PM<sub>2.5</sub>';
                        else if (desc === 'NO2') desc = 'NO<sub>2</sub>';
                        else if (desc === 'SO2') desc = 'SO<sub>2</sub>';
                        else if (desc === 'O3') desc = 'O<sub>3</sub>';
                        return desc;
                    }
                }
                return '?';

            },
            checkLastUpdated() {
                if ((this.$moment().unix() - this.lastUpdated) >= 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
                    this.pageReload(null, false);
                }
            }
        }

    };
</script>

<style lang="scss">

    .smogdetail {
        .item-after {
            color: var(--f7-color-primary);
            font-weight:bold;
            .f7-icons {
                font-size:1rem;
            }
        }
        .item-title {
            font-size: 0.9rem;
        }
        .item-subtitle {
            color: var(--f7-list-item-footer-text-color);
            font-size: var(--f7-list-item-footer-font-size);
        }

        .level-1 {
            background-color: yellow !important;
        }

        .level-2 {
            background-color: orange !important;
        }

        .level-3 {
            background-color: red !important;
            color: white !important;
            .item-title,
            .item-subtitle,
            .item-footer {
                color: white !important;
            }
            .item-after {
                .f7-icons.stav-1 {
                    color: var(--f7-color-red-tint) !important;
                }
            }
        }

    }


</style>
